import styled, { css } from 'styled-components';
import { BackgroundType, ImageSizingType } from '../../../types/space';

interface SpaceWrapper {
  config: any;
}

const ContainerMixin = css`
  border-radius: 4px;
  cursor: pointer;
  position: absolute !important;
`;

const SpaceMixin = css`
  box-sizing: border-box;
  height: 100%;
  max-width: 100%;
  width: 100%;
  max-width: 100%;
`;

export const ContainerInner = styled.div`
  overflow: hidden;
`;

export const FontMixin = (fontConfig: any) => css`
  font-family: ${fontConfig.font || 'Arial, Roboto'};
  font-weight: ${fontConfig.fontWeight || '500'};
  font-size: ${fontConfig.fontSize || 14}px;
  line-height: ${fontConfig.lineHeight || 'normal'};
  color: ${fontConfig.textColor || 'inherit'};
`;
export const AlignmentMixin = (fontConfig: any) => css`
  display: flex;
  align-items: ${fontConfig.verticalAlign || 'flex-start'};
  justify-content: ${fontConfig.horizontalAlign || 'flex-start'};
`;

const BackgroundMixin = (config: any) => css`
  background-color: ${config.background === BackgroundType.Transparent
    ? 'transparent'
    : config.backgroundColor};
  border-radius: ${config.borderRadius || 0}px;
  padding: ${config.padding || 0}px;
`;

export const SpaceWrapper = styled.div<SpaceWrapper>`
  ${ContainerMixin}
`;

export const SpaceBackConfig = styled.div<SpaceWrapper>`
  ${SpaceMixin}
  ${(props) => BackgroundMixin(props.config)}
    ${(props) => AlignmentMixin(props.config)}
    & > span {
    ${(props) => FontMixin(props.config)}
  }
  overflow: hidden;

  .treelab-element-wrapper--image {
    ${SpaceMixin}
    object-fit: ${(props) =>
      props.config.imageSizing === ImageSizingType.Fit
        ? 'contain'
        : props.config.imageSizing === ImageSizingType.Fill
        ? 'cover'
        : props.config.imageSizing === ImageSizingType.Stretch
        ? 'fill'
        : 'contain'};
    /* ${(props) => BackgroundMixin(props.config)} */
  }

  .treelab-element-wrapper--image-multiple {
    ${SpaceMixin}
    & > img {
      ${(props) => `
        padding: 0 ${props.config.imagePadding || 0}px ${props.config.imagePadding || 0}px 0;
        width: ${props.config.imageSize}px;
        height: ${props.config.imageSize}px;
      `}
      object-fit: cover;
    }
    ${(props) => BackgroundMixin(props.config)}
  }
`;
